import { EXPRESS_API } from 'configs/api/expressApi';
import { IImage } from './types';
import { useMutation } from 'react-query';

interface CreateImageBody {
  fileName: string;
  mimeType: string;
}

const createImage = async (body: CreateImageBody): Promise<IImage> => {
  return (await EXPRESS_API.post('/images/user', body)).data;
};

export const useCreateImageMutation = () => {
  return useMutation(createImage);
};
